import React from "react";
import { Router, Link, withSiteData } from "react-static";
import { hot } from "react-hot-loader";
import styled from "styled-components";

import { push as Menu } from "react-burger-menu";

const MobileMenu = styled(Menu)`
  background: white;
  > div && {
    overflow: hidden;
  }
`;

class Example extends React.Component {
  showSettings(event) {
    event.preventDefault();
  }
  render() {
    return (
      <MobileMenu
        width={150}
        right
        pageWrapId={"page-wrap"}
        outerContainerId={"outer-container"}
      >
        <ul>
          <li>
            <Link to="/Kontakt">Kontakt</Link>
          </li>
          {this.props.navPages.map(page => (
            <li key={page.data.slug}>
              <Link to={page.data.slug} key={page.data.slug}>
                {page.data.title}
              </Link>
            </li>
          ))}
        </ul>
      </MobileMenu>
    );
  }
}
export default withSiteData(siteData => <Example {...siteData} />);



// WEBPACK FOOTER //
// /opt/build/repo/src/components/mobile-menu.js